import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { ChecklistService } from 'src/app/_services/checklist.service';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { MixpanelService } from 'src/app/_services/mixpanel.service';
import { PmvService } from 'src/app/_services/pmv.service';
import { ErrorUtil } from 'src/app/_utilities/error';
@Component({
    selector: 'app-update-status',
    templateUrl: './update-status.component.html',
    styleUrls: ['./update-status.component.scss'],
    standalone: false
})
export class UpdateStatusComponent implements OnInit {
  buttonLabel: any;
  data: any
  satatus: any ;
  status: any ;
  translate: any;
  constructor(public modalRef: BsModalRef,
    private checklistService: ChecklistService,
    private errorUtil: ErrorUtil,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private router: Router,
    private pmvService: PmvService,
    private languageTranslateService: LanguageTranslateService,
    private mixPanelService: MixpanelService
) { 
      
    }

  ngOnInit(): void {
    console.log(this.data)
    this.languageTranslateService.wordSrc$.subscribe(data => { 
      if(Object.keys(data).length != 0){
        this.translate = data
        this.status = this.translate?.general.status.new.singular
        this.satatus = [
          { label: this.translate?.general.status.new.singular, value: "NEW" },
          { label: this.translate?.general.status.draft.singular, value: "DRAFT" },
          { label: this.translate?.general.status.completed.singular, value: "COMPLETED" },
          { label: this.translate?.general.status.cancelled.singular, value: "CANCELED" },
         ]
        this.buttonLabel = this.translate?.general.buttons.save.singular
      }
    })
    if (this.data.mode === "edit") {
      this.status = this.data.status
    }
  }

  onSubmitData() {
    if (this.data.page == 'PMV') {
      this.savePMVData()
    } else {
      this.saveChecklistData()
    }

  }
  /******************************************* Save PMV Data *****************************************/
  savePMVData() {
    this.spinner.show()
    //delete addVisit.requestedToUser
    // any form stuff for edit
    if (this.data.mode === "add") {
      let checklistData: any = {

        tmplChecklist: this.data.checklistRecord.tmplChecklist,
        status: this.status,
        assets: this.data.asset,
        checklistQuestions: this.data.checklistQuestions

      }

      console.log(checklistData);
      ////
      this.spinner.show()
      this.pmvService.createPMV(checklistData).subscribe((res: any) => {
        console.log("res", res)

        if (res.status == 200 || res.status == 201) {

          this.modalRef.hide()
          if (!this.data.tmplChecklistData.displayAssetStatusAtEnd && !this.data.tmplChecklistData.displayEquipmentReadingAtEnd) {
            var pmvRecordId = res.body.pmv.id

           
            var saveData = {
              id: pmvRecordId,
              beforeAssetsStatus: this.data.filter.beforeAssetsStatus ? { "id": this.data.filter.beforeAssetsStatus } : null,
              beforeEquipmentReading: this.data.filter.beforeEquipmentReading,
              afterEquipmentReading: this.data.filter.afterEquipmentReading,
              afterAssetsStatus: this.data.filter.afterAssetsStatus ? { "id": this.data.filter.afterAssetsStatus } : null
            }

            this.checklistService.updateBeforeAndAfterData(saveData).subscribe((res: any) => {
              this.spinner.hide()
              if (res) {
                console.log(res)
                this.checklistService.refreshViewRoute(null);
                this.router.navigate(['dashboard/pmv/view'], { queryParams: { id: pmvRecordId } })
              }
            }, (err) => {
              this.spinner.hide()
              const title = this.errorUtil.processErrorTitle(err.error, this.translate)
              this.errorUtil.setErrorMessage(400, null, title, 'error', 3000);

            })
           
          } else {
            this.checklistService.refreshViewRoute(res.body);

          }
        } else {
          this.errorUtil.setErrorMessage(res.status, null, res.error.title, "error", 3000);
        }
        this.spinner.hide()
      })

    }
    // any form stuff for edit
    if (this.data.mode === "edit") {
      let checklistData: any = {
        id: this.data.id,
        tmplChecklist: this.data.tmplChecklist,
        status: this.status,
        assets: this.data.asset,
        checklistQuestions: this.data.checklistQuestions,
        pmv: {
          id: this.data.id,
          status: this.status
        }

      }

      console.log(checklistData);

      this.pmvService.editPMV(checklistData).subscribe((res: any) => {
        console.log("res", res)
        if (res.status == 200 || res.status == 201) {

          this.router.navigate(['dashboard/pmv/view'], { queryParams: { id: this.data.id } })
          this.modalRef.hide()
        } else {

          var errorTitle = res.error.title
          if (res.error.type == 'dynamic-lang-error') {
            var data = res.error.instance + ".validationBE." + res.error.detail;
            var message = this.languageTranslateService.getNestedValue(this.translate, data);
            errorTitle = message
          }

          this.errorUtil.setErrorMessage(
            res.status,
            null,
            errorTitle,
            "error",
            2000
          );
        }
        this.spinner.hide()
      })

    }

  }
  /******************************************* Save Checklist Data *****************************************/
  saveChecklistData() {

    //delete addVisit.requestedToUser
    // any form stuff for edit
    if (this.data.mode === "add") {
      let checklistData: any = {
        checklistRecord: {
          tmplChecklist: this.data.checklistRecord.tmplChecklist,
          status: this.status,
          assets: this.data.asset
        },
        checklistQuestions: this.data.checklistQuestions

      }

      console.log(checklistData);
      ////
      this.spinner.show()
      this.checklistService.createCheckListGlobal(checklistData).subscribe((res: any) => {
        console.log("res", res)

        if (res.status == 200 || res.status == 201) {
          //webevent janani
          if (this.status === 'COMPLETED') {
            console.log("status is completed");
              //Mixpanel Event Tracking
              if(localStorage.getItem('packageCode') != null && localStorage.getItem('packageCode') != 'Old'){
                this.mixPanelService.track('w_checklist_completed', { propertyName: 'w_checklist_completed', method: 'button_click'});
              }
          }

          this.modalRef.hide()
          if (!this.data.tmplChecklistData.displayAssetStatusAtEnd && !this.data.tmplChecklistData.displayEquipmentReadingAtEnd) {
            var checklistRecordId = res.body.checklistRecord.id
            // var saveData = {
            //   id: null,
            //   beforeEquipmentReading: null,
            //   beforeAssetsStatus: null
            // }
           
            var saveData = {
              id: res.body.checklistRecord.id,
              beforeAssetsStatus: this.data.filter.beforeAssetsStatus ? { "id": this.data.filter.beforeAssetsStatus } : null,
              beforeEquipmentReading: this.data.filter.beforeEquipmentReading,
              afterEquipmentReading: this.data.filter.afterEquipmentReading,
              afterAssetsStatus: this.data.filter.afterAssetsStatus ? { "id": this.data.filter.afterAssetsStatus } : null
            }
            console.log(this.data.filter,"===",saveData)
            
            this.checklistService.updateBeforeAndAfterData(saveData).subscribe((res: any) => {
              this.spinner.hide()
              if (res) {
                console.log(res)
                this.checklistService.refreshViewRoute(null);
                this.router.navigate(['dashboard/checklist/view'], { queryParams: { id: checklistRecordId } })
              }
            }, (err) => {
              this.spinner.hide()
              const title = this.errorUtil.processErrorTitle(err.error, this.translate)
              this.errorUtil.setErrorMessage(400, null, title, 'error', 3000);

            })
           
          } else {
            this.checklistService.refreshViewRoute(res.body);

          }
        } else {

          var errorTitle = res.error.title
          if (res.error.type == 'dynamic-lang-error') {
            var data = res.error.instance + ".validationBE." + res.error.detail;
            var message = this.languageTranslateService.getNestedValue(this.translate, data);
            errorTitle = message
          }

          this.errorUtil.setErrorMessage(
            res.status,
            null,
            errorTitle,
            "error",
            2000
          );
        }
        this.spinner.hide()
      })

    }
    // any form stuff for edit
    if (this.data.mode === "edit") {
      let checklistData: any = {
        checklistRecord: {
          id: this.data.id,
          tmplChecklist: this.data.tmplChecklist,
          status: this.status,
          assets: this.data.asset
        },
        checklistQuestions: this.data.checklistQuestions

      }

      console.log(checklistData);
      ////
      //  return;
      this.checklistService.editCheckListGlobal(checklistData).subscribe((res: any) => {
        console.log("res", res)
        if (res.status == 200 || res.status == 201) {
          this.modalRef.hide()
          if (this.data.tmplChecklistData.displayAssetStatusAtEnd && this.data.tmplChecklistData.displayEquipmentReadingAtEnd) {
            this.checklistService.refreshViewRoute({ isUpdated: true, ...res.body, assets: this.data.asset });
          } else {
            this.checklistService.refreshViewRoute(null);
            this.router.navigate(['dashboard/checklist/view'], { queryParams: { id: this.data.id } });
          }
        } else {
          this.errorUtil.setErrorMessage(res.status, null, res.error.title, "error", 3000);
        }
        this.spinner.hide()
      })

    }

  }

}
